import { useGetDevice } from "../../../api/userInfo"
import { DeviceFieldSetup } from "./deviceFieldSetup"
import RoomStateSetup from "./multipleFields/RoomStateSetup"
import MultipleFieldWithIconSetup from "./multipleFields/multiFieldWIthIcon"
import MultipleFieldSetup from "./multipleFields/multipleFieldSetup"
import {SingleFieldSetup, SingleFieldSetupV2} from "./singleFieldSetup"
import {SetupTitleOnly} from "./widgetTitleSetup"
import { WidgetTitleTypeSetup } from "./widgetTitleTypeSetup.js"

import { useWidgetSetupStore } from "../../../context/stores"
import {shallow} from 'zustand/shallow'
import { useEffect } from "react"
import { ChillerWidgetSetup } from "./chillerWidgetSetup"
import { SingleDeviceSetup } from "./singleDeviceSetup"
import { useWidgetSetupDetails } from "src/api/dashboard"
import { useTranslation } from 'react-i18next'

const GetSetupFields = ({submitForm, clearForm, isEdit=false,widgetDetails}) => {
    
    const selectedWidget = useWidgetSetupStore((state) => state?.selectedWidget)
    const [setupDetails, updateSetupDetails] = useWidgetSetupStore((state) => [state.setupDetails, state.updateSetupDetails],shallow )
    const [widgetIcon, updateWidgetIcon] = useWidgetSetupStore((state) => [state.widgetIcon, state.updateWidgetIcon],shallow )
    const [widgetTitle, updateWidgetTitle] = useWidgetSetupStore((state) => [state.widgetTitle, state.updateWidgetTitle],shallow )
    const { t } = useTranslation("settings");
   
    const clear_fields = () => {
        updateSetupDetails({})
        updateWidgetIcon('')
        updateWidgetTitle('')
    }
    
    
    let inputFields = {}
    switch (selectedWidget) {
        case "Solar Widget (Total)":
        case 'Solar Widget':
        case 'Cost Saved Widget':
        case 'Carbon Avoid Widget':
        case 'Standard Coal Saved Widget':
        case 'Potential Rec Earn Widget':
        case 'Equivalent Trees Planted Widget':
            
        case 'Total Value Widget':
        // case 'Performance Device Listed':
        case 'Gas Widget':
        case 'Performance Widget':
            return <SingleFieldSetup
                        widgetDetails={widgetDetails} //contain data of widget from api
                        selectedWidget={selectedWidget} 
                        updateWidgetTitle={updateWidgetTitle}
                        updateSetupDetails={updateSetupDetails}
                        setupDetails={setupDetails} 
                        updateWidgetIcon={updateWidgetIcon} 
                        
                        submitForm={submitForm}
                        clearForm={clearForm}
                    />

        case 'Single Device Widget':
            return <SingleDeviceSetup 
                    widgetDetails={widgetDetails} //contain data of widget from api
                    selectedWidget={selectedWidget} 
                    updateSetupDetails={updateSetupDetails}
                    setupDetails={setupDetails} 
                    updateWidgetIcon={updateWidgetIcon} 
                    
                    widgetIcon={widgetIcon}
                    submitForm={submitForm}
                    clearForm={clearForm}
                    />

        case 'Circle Device Status Widget': 
        case 'Net Zero Widget': 
            return <SetupTitleOnly 
            widgetDetails={widgetDetails} //contain data of widget from api
            submitForm={submitForm} 
            updateWidgetTitle={updateWidgetTitle} 
            clearForm={clearForm} />

        case 'Battery Alarm Widget':
        case 'Rectifier Widget':
            return <DeviceFieldSetup 
                        widgetDetails={widgetDetails} //contain data of widget from api
                        updateWidgetTitle={updateWidgetTitle}
                        selectedWidget={selectedWidget} 
                        updateSetupDetails={updateSetupDetails}
                        setupDetails={setupDetails} 
                        updateWidgetIcon={updateWidgetIcon} 
                        
                        submitForm={submitForm}
                        clearForm={clearForm}
            />
            
        case 'Performance Device Listed':
            return <WidgetTitleTypeSetup 
                    widgetDetails={widgetDetails} //contain data of widget from api
                    updateSetupDetails={updateSetupDetails}
                    setupDetails={setupDetails}
                    updateWidgetTitle={updateWidgetTitle}
                    submitForm={submitForm} 
                    clearForm={clearForm} 
                    />
        case 'Current Status Widget':
            inputFields = {'title':'', 'device':'', 'unit':'', 'field':''}
            return <MultipleFieldSetup 
                        widgetDetails={widgetDetails} //contain data of widget from api
                        updateSetupDetails={updateSetupDetails}
                        setupDetails={setupDetails} 
                        
                        // widgetIcon={widgetIcon}
                        submitForm={submitForm}
                        clearForm={clearForm}
                        />
                    
        case 'Line Chart':
        case 'Radar Chart':
        case 'Line Chart V2':
        case 'Radar Chart Widget':
            inputFields = {'title':'', 'device':'', 'unit':'', 'field':'', 'show_y_axis':true}
            return <MultipleFieldWithIconSetup
                        widgetDetails={widgetDetails} //contain data of widget from api
                        selectedWidget={selectedWidget} 
                        updateSetupDetails={updateSetupDetails}
                        setupDetails={setupDetails} 
                        updateWidgetIcon={updateWidgetIcon} 
                        isChart={true}
                        // widgetIcon={widgetIcon}
                        inputFields={inputFields}
                        submitForm={submitForm}
                        clearForm={clearForm}
                        />
        case 'Overview Widget':
            inputFields = {'title':'', 'device':'', 'unit':'', 'field':''}
            return <MultipleFieldWithIconSetup
                        widgetDetails={widgetDetails} //contain data of widget from api
                        selectedWidget={selectedWidget} 
                        updateSetupDetails={updateSetupDetails}
                        setupDetails={setupDetails} 
                        updateWidgetIcon={updateWidgetIcon} 
                        isChart={false}
                        // widgetIcon={widgetIcon}
                        inputFields={inputFields}
                        submitForm={submitForm}
                        clearForm={clearForm}
                        />
                    
        case 'Room State Widget':
            inputFields = {'title':'', 'device':'', 'unit':'', 'field':''}
            return <RoomStateSetup
                     widgetDetails={widgetDetails} //contain data of widget from api
                        selectedWidget={selectedWidget} 
                        updateSetupDetails={updateSetupDetails}
                        setupDetails={setupDetails} 
                        updateWidgetIcon={updateWidgetIcon}
                        updateWidgetTitle={updateWidgetTitle}
                        
                        // widgetIcon={widgetIcon}
                        inputFields={inputFields}
                        submitForm={submitForm}
                        clearForm={clearForm}
                        
                        />

        case 'Chiller Widget':
        case 'Chiller_1A Widget':
            return <ChillerWidgetSetup 
                widgetDetails={widgetDetails} //contain data of widget from api
                updateWidgetTitle={updateWidgetTitle}
                selectedWidget={selectedWidget} 
                updateSetupDetails={updateSetupDetails}
                setupDetails={setupDetails} 
                updateWidgetIcon={updateWidgetIcon} 
                
                submitForm={submitForm}
                clearForm={clearForm}
            />
        
            

        default:
            let style=isEdit? "flex items-center mt-4 opacity-50 w-full":"flex items-center mt-4 opacity-50 w-72"
            let description =isEdit? "edit":"setup"
            return <div className={style}><p>{t('dashboard_setup.message_config')}</p></div>
    }
}
 
export default GetSetupFields;

